let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fyS0J"), load("dx9iv"), load("3ooAX"), load("2nh75"), load("acQiP"), load("2MuhG")]).then(() => parcelRequire('gelCt'));